// extracted by mini-css-extract-plugin
export var buttons = "_bx-0";
export var buttonsActive = "_bx-h";
export var cancelConfirm = "_bx-1";
export var closeButton = "_bx-2";
export var column = "_bx-3";
export var container = "_bx-4";
export var detailHeader = "_bx-6";
export var detailTitle = "_bx-7";
export var detailsContent = "_bx-5";
export var header = "_bx-8";
export var headerWithClose = "_bx-9";
export var icon = "_bx-a";
export var infoIcon = "_bx-c";
export var informationContainer = "_bx-b";
export var sideDrawer = "_bx-d";
export var sideDrawerOpen = "_bx-e";
export var stickyFooter = "_bx-f";
export var typeOption = "_bx-g";